const defaultState = {
	plants: [],
	useYnList: [],
	gridUseYnList: [],
	searchParams: {
		plantCd: '',
		userGrpName: null,
		userName: null,
		useYn: null
	},

	resultList: [],
	groups: {
		currentPage: 1,
		pageUnit: 10,
		totalSize: 0
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
